
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34","height":"32","width":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"fill-rule":"nonzero","fill":"#000"}},[_c('path',{attrs:{"d":"M23.213 23.162H8.787V8.73h14.426v14.432zm-1.5-1.501V18.98h-2.587v2.681h2.587zm-8.437-2.681h-2.99v2.681h2.99V18.98zm4.35 0h-2.85v2.681h2.85V18.98zm4.087-1.5v-3.066h-2.587v3.066h2.587zm-8.437-3.066h-2.99v3.066h2.99v-3.066zm4.35 0h-2.85v3.066h2.85v-3.066zm4.087-1.5V10.23h-2.587v2.684h2.587zm-8.437-2.684h-2.99v2.684h2.99V10.23zm4.35 0h-2.85v2.684h2.85V10.23z","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"d":"M27.111 15.583a.75.75 0 01.102 1.493l-.102.007h-4.267a.75.75 0 01-.102-1.493l.102-.007h4.267zM9.156 15.583a.75.75 0 01.102 1.493l-.102.007H4.932a.75.75 0 01-.102-1.493l.102-.007h4.224zM16.156 21.882a.75.75 0 01.744.648l.006.102v4.437a.75.75 0 01-1.493.102l-.007-.102v-4.437a.75.75 0 01.75-.75zM16.156 4.29a.75.75 0 01.744.648l.006.101V9.3a.75.75 0 01-1.493.102l-.007-.102V5.04a.75.75 0 01.75-.75z","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"d":"M28 4v24H4V4h24zm-1.286 1.286H5.286v21.428h21.428V5.286z","vector-effect":"non-scaling-stroke"}})])])])
          )
        }
      }
    